<template>
  <van-swipe :autoplay="3000" class="my-swipe" indicator-color="white">
    <van-swipe-item v-for="item in banner" :key="item.src">
      <a :href="item.url" :target="item.target">
        <img :src="item.src" class="banner-top"/>
      </a>
    </van-swipe-item>
  </van-swipe>
</template>

<script>
export default {
  name: "Banner",
  data() {
    return {
      banner: []
    }
  },
  created() {
    this.$axios.post(this.$apiconfg.banner).then(({data}) => {
      this.banner = data.data.h5
    })
  }
}
</script>

<style scoped>
.banner-top{

}
</style>